export default __webpack_public_path__ + "static/media/logo-white-normal.91196067.svg";